import { Table } from "@/pages/a7/Table";
import { type A7FIATimeSerieFile, getTimeSerieFilesColumns } from "./columns";
import {
  type FilterA7FIATimeSerieFilesSchema,
  FilterA7FIATimeSerieFiles,
} from "./filter";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const table_name = "a7_fia_time_serie_files";

export const A7FIATimeSerieFilesTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(
    () => getTimeSerieFilesColumns(t),
    [t, i18n.language],
  );
  const columnVisibilityInit = {
    filename: false,
  };

  return (
    <Table<A7FIATimeSerieFile, FilterA7FIATimeSerieFilesSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Files",
      })}
      client={"a7"}
      table_name={table_name}
      columns={columns}
      columnVisibilityInit={columnVisibilityInit}
      filter={
        <FilterA7FIATimeSerieFiles client={"a7"} table_name={table_name} />
      }
      actions={[]}
      // new_item={
      //   <NewItemWrapper form={form} onSubmit={uploadFiles}>
      //     <div className="flex flex-col gap-6 items-center">
      //       <div className="w-40">
      //         <DatePickerField
      //           name="date"
      //           label="Date"
      //           isRequired={true}
      //           control={form.control}
      //         />
      //       </div>
      //       <NewItem
      //         setFiles={(files) => setFiles(files ? Array.from(files) : [])}
      //       />
      //     </div>
      //   </NewItemWrapper>
      // }
    />
  );
};
